import React, { useMemo } from 'react'
import { Platform, ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useRouter } from 'expo-router'
import { useThrottledCallback } from 'use-debounce'

import { styles } from '../profile-screen/styles'
import { MainHeader } from '../../components/MainHeader/MainHeader'
import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../models'
import { TeachingTableGameModelType } from '../../models/api-store'
import ItemSchedule from '../../components/ANewDesign/ItemSchedule/ItemSchedule'
import { DS } from '../../design-system'
import useFetchTeachingTables from '../../hooks/useFetchTeachingTables'

const FullScheduleScreen = observer(() => {
  const router = useRouter()
  const {
    game: { scheduledTeachingTables }
  } = useStore()

  //useFetchTeachingTables()

  const sectionedData: {
    thisWeek: TeachingTableGameModelType[]
    nextWeek: TeachingTableGameModelType[]
    upcoming: TeachingTableGameModelType[]
  } = useMemo(() => {
    const getStartOfWeek = (date: Date): Date => {
      const day = date.getDay()
      const diff = date.getDate() - day
      const startOfWeek = new Date(date.setDate(diff))
      startOfWeek.setHours(0, 0, 0, 0)
      return startOfWeek
    }

    const startOfThisWeek = getStartOfWeek(new Date())
    const startOfNextWeek = new Date(startOfThisWeek)
    startOfNextWeek.setDate(startOfNextWeek.getDate() + 7)
    const startOfFollowingWeek = new Date(startOfNextWeek)
    startOfFollowingWeek.setDate(startOfFollowingWeek.getDate() + 7)

    const thisWeek: TeachingTableGameModelType[] = []
    const nextWeek: TeachingTableGameModelType[] = []
    const upcoming: TeachingTableGameModelType[] = []

    scheduledTeachingTables.forEach((item) => {
      const scheduleDate = new Date(item.scheduleTime)

      if (scheduleDate >= startOfThisWeek && scheduleDate < startOfNextWeek) {
        thisWeek.push(item)
      } else if (scheduleDate >= startOfNextWeek && scheduleDate < startOfFollowingWeek) {
        nextWeek.push(item)
      } else {
        upcoming.push(item)
      }
    })

    return { thisWeek, nextWeek, upcoming }
  }, [scheduledTeachingTables])

  const goBack = useThrottledCallback(
    () => {
      router.replace('/profile')
    },
    350,
    { leading: true }
  )

  const UpcomingEventSection = (props: { title: string; data: TeachingTableGameModelType[] }) => {
    if (props.data.length === 0) {
      return null
    }

    return (
      <DS.Frame>
        <DS.Text variant="Heading 3/Medium" style={{ marginBottom: 12 }}>
          {props.title}
        </DS.Text>
        <DS.Frame style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', padding: 16, gap: 16, borderRadius: 16 }}>
          {props.data.map((schedule, i) => {
            return (
              <DS.Frame key={`upcoming-event-${schedule.scheduleId}-${i}`} style={{ gap: 16 }}>
                <ItemSchedule item={schedule} />
                {i !== props.data.length - 1 && (
                  <DS.Frame
                    style={{
                      height: 1,
                      backgroundColor: DS.palette['Brand/Light Grey']
                    }}
                  />
                )}
              </DS.Frame>
            )
          })}
        </DS.Frame>
      </DS.Frame>
    )
  }

  return (
    <SafeAreaView style={[styles.container, { paddingTop: Platform.OS === 'android' ? 25 : 0 }]}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <MainHeader leftPress={goBack} title={'Full Schedule'} titleStyle={{ color: '#121212' }} />
      <ScrollView style={{ flex: 1, paddingHorizontal: 24 }} contentContainerStyle={{ gap: 24 }}>
        <UpcomingEventSection title={'This week'} data={sectionedData.thisWeek} />
        <UpcomingEventSection title={'Next week'} data={sectionedData.nextWeek} />
        <UpcomingEventSection title={'Upcoming'} data={sectionedData.upcoming} />
      </ScrollView>
    </SafeAreaView>
  )
})

export default FullScheduleScreen
